/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { MarkConversationAsReadApiArg, MarkReadData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    markConversationAsRead: build.mutation<MarkReadData, MarkConversationAsReadApiArg>({
      query: (queryArg) => ({
        body: undefined,
        method: 'POST',
        url: `/v1/conversations/${queryArg.conversationId}/mark-read`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as markConversationAsReadApi };
export const { useMarkConversationAsReadMutation } = injectedRtkApi;
